export default {
    drap_drop_container_success_message: "El registro se ha borrado correctamente",
    drap_drop_container_delete_gadget: "Borrar Gadget"
}